var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("../../../assets/loading.gif"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }